import {
  Clock3,
  Footprints,
  IndianRupee,
  Mars,
  Megaphone,
  Monitor,
  Star,
  Venus,
} from 'lucide-react';
import type { StatCardConfig } from '../types/totalAnalytics.types';

const ICONS: Record<StatCardConfig['iconKey'], React.ReactNode> = {
  campaign: <Megaphone className="h-5 w-5 text-blue-600" />,
  cost: <IndianRupee className="h-5 w-5 text-emerald-600" />,
  views: <Monitor className="h-5 w-5 text-indigo-600" />,
  male: <Mars className="h-5 w-5 text-slate-700" />,
  female: <Venus className="h-5 w-5 text-rose-600" />,
  footfall: <Footprints className="h-5 w-5 text-amber-600" />,
  engagement: <Star className="h-5 w-5 text-amber-600" />,
  dwell: <Clock3 className="h-5 w-5 text-emerald-600" />,
};

export function AnalyticsStatIcon({
  iconKey,
}: {
  iconKey: StatCardConfig['iconKey'];
}) {
  return ICONS[iconKey];
}
